import React, { Component } from 'react'
import URLUtils from '../../util/URLUtils'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import SignUpWithPhonePageUI from './SignUpWithPhonePageUI.js'

class SignUpWithPhonePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      captchaKey: null,
      messageList: null,
      socialLoginUrl: null,
      signUpWithPassword: false,
      // phone number
      phoneNumber: '',
      phoneNumberError: null,
      // verification code
      verifCode: '',
      verifCodeError: null,
      // pin code
      pinCode: '',
      pinCodeError: null,
      // view
      view: 'phoneNumber' // other values 'verification', 'pinCode'
    }
  }

  render() {
    return (
      <SignUpWithPhonePageUI
        context={this.props.context}
        messageList={this.state.messageList}
        // phone number
        phoneNumber={this.state.phoneNumber}
        onPhoneNumberChange={(value) => { this.setState({ phoneNumber: value }) }}
        phoneNumberError={this.state.phoneNumberError}
        setPhoneNumberError={(error) => { this.setState({ phoneNumberError: error }) }}
        // verification code
        verifCode={this.state.verifCode}
        onVerifCodeChange={(event) => { this.setState({ verifCode: event.target.value }) }}
        verifCodeError={this.state.verifCodeError}
        setVerifCodeError={(error) => { this.setState({ verifCodeError: error }) }}
        // pin code
        pinCode={this.state.pinCode}
        onPinCodeChange={(event) => { this.setState({ pinCode: event.target.value }) }}
        pinCodeError={this.state.pinCodeError}
        setPinCodeError={(error) => { this.setState({ pinCodeError: error }) }}
        // view
        view={this.state.view}
        setView={(view) => { this.setState({ view: view }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  onSignUpWithPasswordClick = (event) => {
    this.setState({ signUpWithPassword: true })
  }

  getCaptchaPublicKey(context) {
    let cacheManager = new CacheManager({
      resource: '/api/pub/reCaptcha/publicKey',
      cacheKey: CacheKeys.CaptchaKey,
      callback: this.getCaptchaPublicKeyCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, {})
  }

  getCaptchaPublicKeyCallback = (response) => {
    this.setState({ captchaKey: response.publicKey })
  }

  getSocialLoginUrl(context) {
    let cacheManager = new CacheManager({
      resource: '/api/pub/socialLoginUrl',
      cacheKey: CacheKeys.SocialLoginUrl,
      callback: this.getSocialLoginUrlCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context, {}, { baseUrl: URLUtils.getBaseURL() })
  }

  getSocialLoginUrlCallback = (response) => {
    this.setState({ socialLoginUrl: response })
  }

  getMessages(context) {
    let arr = [
      'c_signup_agreeto_terms',
      'c_sign_up',
      'c_verify_phone',
      'c_re_signup',
      'c_set_pin'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_signup_w_ph', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }

}

export default SignUpWithPhonePageSF
